var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"m-the-alerts"},[_c('transition-group',{attrs:{"name":"a-alert-primary-fade"}},_vm._l((_vm.$alerts.alerts),function(alert,index){return _c('AtomAlertPrimary',{key:`alert-${index}`,attrs:{"alert":alert,"index":index}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }